import { Injectable } from '@angular/core';

@Injectable()
export class ConfigService {
    hostAddress: string;

    constructor() {
        if (window.location.host.toLowerCase().indexOf('localhost') >= 0 || window.location.host === '127.0.0.1') {
            this.hostAddress = 'http://localhost:31212/';
        } else {
            if (window.location.host.toLowerCase().indexOf("apptest.polk") >= 0) {
                // New server pre-DNS change
                this.hostAddress = 'https://apptest.polk-fl.net/';
            } else if (window.location.host.toLowerCase().indexOf('delta.polk') >= 0) {
                // PRD
                this.hostAddress = 'https://delta.polk-fl.net/';
            } else {
                // DEV
                this.hostAddress = 'https://deltadev.polk-fl.net/';
            }

        }
    }
}


// WEBPACK FOOTER //
// ./src/services/config/config.service.ts